/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchCollection } from './SearchCollection';
import {
    SearchCollectionFromJSON,
    SearchCollectionFromJSONTyped,
    SearchCollectionToJSON,
} from './SearchCollection';

/**
 * 
 * @export
 * @interface SearchCollectionsResponse
 */
export interface SearchCollectionsResponse {
    /**
     * 
     * @type {Array<SearchCollection>}
     * @memberof SearchCollectionsResponse
     */
    collections: Array<SearchCollection>;
}

/**
 * Check if a given object implements the SearchCollectionsResponse interface.
 */
export function instanceOfSearchCollectionsResponse(value: object): value is SearchCollectionsResponse {
    if (!('collections' in value) || value['collections'] === undefined) return false;
    return true;
}

export function SearchCollectionsResponseFromJSON(json: any): SearchCollectionsResponse {
    return SearchCollectionsResponseFromJSONTyped(json, false);
}

export function SearchCollectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCollectionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'collections': ((json['collections'] as Array<any>).map(SearchCollectionFromJSON)),
    };
}

export function SearchCollectionsResponseToJSON(value?: SearchCollectionsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'collections': ((value['collections'] as Array<any>).map(SearchCollectionToJSON)),
    };
}

